import { PERMS, type UiNode } from './types.ts'

/**
 * Tab của Chứng từ MH (`/az/purchase-docs`). Màn khai ở `ops.ts`; tách tệp vì cùng tệp màn `ap.tsx` với Phải trả.
 * Màn KHÔNG đọc `?tab=` — `?stmt=<mã bảng kê>` là link sâu tới một bảng kê (tự chọn tab theo loại), không phải tham số tab.
 */
export const PURCHASE_DOCS_NODES: readonly UiNode[] = [
  { id: 'purchaseDocs.statements', kind: 'tab', parent: 'purchaseDocs', tab: 'statements', perms: ['view', 'edit', 'create'] }, // 📋 Bảng kê NCC
  { id: 'purchaseDocs.jobfee', kind: 'tab', parent: 'purchaseDocs', tab: 'jobfee', perms: PERMS }, // 🧾 Chi phí khác ĐH
  { id: 'purchaseDocs.jobfee.pending', kind: 'tab', parent: 'purchaseDocs.jobfee', tab: 'pending', perms: ['view', 'create'] }, // 📋 Chờ lập bảng kê
  { id: 'purchaseDocs.jobfee.stmts', kind: 'tab', parent: 'purchaseDocs.jobfee', tab: 'stmts', perms: ['view', 'edit', 'export'] }, // 🧾 Bảng kê đã lập
  { id: 'purchaseDocs.invoices', kind: 'tab', parent: 'purchaseDocs', tab: 'invoices', perms: ['view', 'edit', 'export'] }, // 🧾 Hóa đơn MH
]
